import RouterLayout from "./Component/Router/RouterLayout";


function App() {
  return (
    <>
      <RouterLayout />
      
    </>
  );
}

export default App;
